//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from "@angular/core";

//local imports
import { PresenterRegistration } from "@app/shared";
import { AbstractDepartmentModel } from "@app/catalog-common";


@PresenterRegistration({
   types: [AbstractDepartmentModel],
})
@Component({
    selector: 'department-presenter',
    template: '<department-item [id]="data().id" [department]="data()" />',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DepartmentPresenterComponent {
    public data: WritableSignal<AbstractDepartmentModel>;
    
    constructor() {
        this.data = signal<AbstractDepartmentModel>(null);
    }
}